<div class="week-calendar" (click)="closePopup()">
  <!-- Cabeçalho com navegação -->
  <div class="calendar-header">
    <div class="week-navigation">
      <button class="nav-button" (click)="previousWeek()">
        <img src="assets/icons/arrowBack.png" alt="Semana anterior" class="nav-icon">
      </button>

      <h2 class="calendar-title">{{ currentMonthYear }}</h2>

      <button class="nav-button" (click)="nextWeek()">
        <img src="assets/icons/arrowNext.png" alt="Próxima semana" class="nav-icon">
      </button>
    </div>
  </div>

  <!-- Estados de loading/error -->
  <div class="loading-state" *ngIf="loading">
    <div class="spinner"></div>
    <p>Carregando agendamentos...</p>
  </div>

  <div class="error-state" *ngIf="error && !loading">
    <div class="error-icon">⚠️</div>
    <p>Erro ao carregar agendamentos</p>
    <button class="retry-button" (click)="loadAppointmentsForWeek()">Tentar novamente</button>
  </div>

  <!-- Calendário semanal -->
  <div class="calendar-container" *ngIf="!loading && !error">

    <!-- Grade de calendário -->
    <div class="calendar-grid">

      <!-- Canto superior esquerdo vazio -->
      <div class="grid-corner"></div>

      <!-- Cabeçalho dos dias -->
      <div class="day-header" *ngFor="let day of weekDays; let dayIndex = index"
           [class.today-column]="day.isToday"
           [attr.data-day-index]="dayIndex">
        <div class="day-name">{{ day.dayName | uppercase }}</div>
        <div class="day-number">{{ day.dayNumber }}</div>
      </div>

      <!-- Linhas de horários -->
      <ng-container *ngFor="let timeSlot of timeSlots; let timeIndex = index">

        <!-- Coluna de horários à esquerda -->
        <div class="time-label" *ngIf="timeSlot.hour.endsWith(':00')">
          <span class="time-text">{{ timeSlot.formattedHour }}</span>
        </div>
        <div class="time-label empty" *ngIf="!timeSlot.hour.endsWith(':00')"></div>

        <!-- Células para cada dia -->
        <div class="calendar-cell" *ngFor="let day of weekDays; let dayIndex = index"
             [class.today-column]="day.isToday"
             [class.half-hour]="!timeSlot.hour.endsWith(':00')"
             [attr.data-day-index]="dayIndex">

          <!-- Divisores internos -->
          <div class="cell-divider vertical"></div>
          <div class="cell-divider horizontal" *ngIf="!timeSlot.hour.endsWith(':00')"></div>

          <!-- Agendamentos nesta célula -->
          <div class="cell-appointments">
            <div class="appointment-rectangle"
                 *ngFor="let apt of getAppointmentsForCell(dayIndex, timeIndex)"
                 [style.top.px]="apt.startPosition"
                 [style.height.px]="25"
                 (click)="onAppointmentClick($event, apt.appointment)">

              <div class="appointment-content">
                <div class="client-info">
                  <span class="client-name">{{ apt.appointment.nomeCliente }},</span>
                  <span class="appointment-time">{{ apt.appointment.horarioAgendamento }}</span>
                </div>
              </div>

            </div>
          </div>

        </div>

      </ng-container>

    </div>

  </div>

  <!-- Pop-up de detalhes do agendamento -->
<!-- week-calendar.html - ATUALIZANDO O POPUP -->
<div class="appointment-popup"
     *ngIf="showPopup && selectedAppointment"
     [style.left.px]="popupPosition.x"
     [style.top.px]="popupPosition.y"
     (click)="$event.stopPropagation()">

  <div class="popup-content">
    <div class="popup-date">{{ formatDateToDisplay(selectedAppointment.dataAgendamento) }}</div>
    <div class="popup-client">{{ selectedAppointment.nomeCliente }}</div>
    <div class="popup-time">{{ selectedAppointment.horarioAgendamento }}</div>
    <div class="popup-vendedor">Vendedor: {{ selectedAppointment.nomeVendedor || 'Não informado' }}</div>

    <!-- NOVO: Botão para ver detalhes do lead -->
    <button class="lead-details-btn"
            (click)="navigateToLeadDetails(selectedAppointment.idLead)">
      Ver Detalhes do Lead
    </button>
  </div>
</div>
</div>
